import React, { useEffect, useState } from "react";
import "./addApi.css";
import { toast } from "react-toastify";

const AddApi = ({ setAddApi }) => {
  const [textApi, setTextApi] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const storedAddApi = sessionStorage.getItem("AddApi");

  useEffect(() => {
    if (storedAddApi) {
      setTextApi(storedAddApi);
    }
  }, []);

  const handleAddApi = () => {
    sessionStorage.setItem("AddApi", textApi);

    toast.success("The api has been added successfully");
    setAddApi(false);

    setButtonDisabled(true);
  };

  const handleClose = () => {
    setAddApi(false);
  };

  return (
    <div className="AddApi">
      <div className="div_api_keys">
        <a
          href="https://platform.openai.com/api-keys"
          target="_blank"
          className="api_keys"
        >
          Link API KEY
        </a>
      </div>

      <div className="propmt">
        <span onClick={handleClose}>×</span>

        <input
          type="text"
          value={textApi}
          onChange={(e) => setTextApi(e.target.value)}
        />
        <button onClick={handleAddApi} disabled={isButtonDisabled}>
          AddApi
        </button>
      </div>
    </div>
  );
};

export default AddApi;
